/**
 * Copyright 2024-2025 Wingify Software Pvt. Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export enum EventEnum {
  VWO_VARIATION_SHOWN = 'vwo_variationShown',
  VWO_SYNC_VISITOR_PROP = 'vwo_syncVisitorProp',
  VWO_LOG_EVENT = 'vwo_log',
  VWO_INIT_CALLED = 'vwo_fmeSdkInit',
  VWO_USAGE_STATS = 'vwo_sdkUsageStats',
  VWO_DEBUGGER_EVENT = 'vwo_sdkDebug',
}
